import kioskApi from "../../api/kioskApi";

const state = {
  kioskSerialNumber: "",
  kioskNumber: "",
  isKiosk: false,
};

const getters = {
  kioskSerialNumber(state) {
    return state.kioskSerialNumber;
  },
  kioskNumber(state) {
    return state.kioskNumber;
  },
  isKiosk(state) {
    return state.kioskSerialNumber !== "";
  },
};

const mutations = {
  KIOSK_SET_SERIALNUMBER(state, serialNumber) {
    state.kioskSerialNumber = serialNumber;
  },
};

const actions = {
  kioskStartLogin({ commit }, userDetails) {
    //call api to get assigned tests//
    commit("SET_USER_DETAILS", userDetails);
    commit("SET_PAGE", "DateOfBirthLogin");
    commit("SET_LANGUAGE", userDetails.preferredLanguage || "en");
  },
  kioskSetSerialNumber({ commit }, serialNumber) {
    commit("KIOSK_SET_SERIALNUMBER", serialNumber);
  },
  async getKioskExamineeInfo({ dispatch }, serialNumber) {
    dispatch("setBusy");
    const examineeInfo = await kioskApi.getAssignedExaminee(serialNumber);
    dispatch("clearBusy");
    return examineeInfo;
  },
  async intializeKiosk({ dispatch }, serialNumber) {
    dispatch("setBusy");
    const kioskData = await kioskApi.initializeKiosk(serialNumber);
    dispatch("clearBusy");
    return kioskData;
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
